export const FOLDERS_TAB = "FOLDERS"
export const TEMPLATES_TAB = "TEMPLATES"
